import React, {useEffect, useState} from "react";
import { Login } from "pages/LandingPage/Login";
import Register from "pages/LandingPage/Register";
import About from "./Docs";
import Features from "pages/LandingPage/Features";
import { Trans } from "react-i18next";
import { compose, withStateHandlers } from "recompose";
import { useRecoilState } from "recoil";
import { modalState } from "atoms";
import Mailchimb1 from "pages/LandingPage/Mailchimb1";


import {Modal, ModalBody
} from 'reactstrap';
import RegisterUser from "./RegisterUser";

export const LandingPage = ({
  history,
  location,
  client,
  focusFirstName,
  handleToggleFirstName,
  modalType,
  t
}) => { 
  const [modal, setModal] = useRecoilState(modalState);
  // const [modal2, setModal2] = useState(false);
  // const toggle2 = () => setModal2(!modal2);
  const toggle = () => setModal(!modal);
  const [loading, setLoading] = useState(true);

useEffect(() => {
    setLoading(true);
    if (modalType === 'login' || modalType === 'register') {
      setTimeout(() => {
        setLoading(false);
      }, 800); 
    }
  }, [modalType]);

useEffect(() => {
    const isDirectLink = location.pathname === `/${modalType}`;
    
    if (isDirectLink) {
      setModal(true);
    } else {
      setModal(false);
    }
  }, [location.pathname, modalType, setModal]);

  const renderModalContent = () => {
    switch (modalType) {
      case 'login':
        return <Login history={history} toggle={toggle} />;
      case 'register':
        return (
          <Register
            onToggleFirstName={handleToggleFirstName}
            focusFirstName={focusFirstName}
            history={history}
            client={client}
            toggle={toggle}
          />
        );
      default:
        return null;
    }
  };

  const [showModal, setShowModal] = useState(false);

  const handleClose = () => {
    setShowModal(false);
  };

  return (
  <div className="theone">
    <header id="header-6" className="dark-header">
      <div className="container">
        <div className="header-content">
          <div className="row">
            <div className="col-md-6 col-lg-6 header-content-details" id="about-us">
              <h3 className="header-brand">
                <Trans>Welcome to Hesaab Developer Portal </Trans>
              </h3>
              <p>
                <Trans>
                We on <span className="txt-decoration">Hesaab</span> are pleased to welcome you all as partner, utilize this endpoint for all the development integrations and testing.</Trans>
              </p>
              <a
                className="btn btn-primary-filled btn-rounded"
                onClick={() => setShowModal(true)}>
                <Trans>Register</Trans>
              </a> 
              <RegisterUser show={showModal} handleClose={handleClose}/>
              <div>
              <img style={{marginTop:'10px'}}className="w-48"
                src="/images/hessab&xero.svg"
                alt="Arabic Invoicing Solution"
              />
            </div>
             
            </div>
            <div className="col-md-6 col-lg-6">
               <img className="w-100"
                src="/images/hesaab_platform2.png"
                alt="Arabic Invoicing Solution"
              />
            </div>
          </div>
        </div>
      </div>
    </header>
    
    <div className="row">
  <div className="col-md">
  <React.Fragment>
        <div style={{
            display: 'block', padding: 30
        }}>
            <Modal isOpen={modal}
                toggle={toggle}
                >
                <ModalBody>
                {loading ? 'Loading...' : renderModalContent()}
                </ModalBody>
            </Modal>
        </div >
      </React.Fragment>
  </div>
</div>
    <About />
    <Features />

    <section id="newsletter">
    <div className="container">
        <div className="header-content">
          <div className="row justify-content-center">
            <div className="col-md-6 col-lg-6" >
        <h3 className="txt-title">
                <Trans>Let’s keep in touch</Trans>
              </h3>
              <p className="txt-content">
                <Trans>
                Kindly subscribe to our mailing list to get the update in your email
                </Trans>
              </p>
              <Mailchimb1/>
        </div>
        </div>
        </div>
        </div>
        </section>
  </div>
)};

export const enhance = compose(
  withStateHandlers(
    {},
    {
      setFocusFirstName:
        (_, { location, history }) =>
        (focusFirstName) => {
          if (location.pathname !== "/register") {
            history.push("/register");
          }
          return { focusFirstName };
        },
      handleToggleFirstName:
        ({ focusFirstName }) =>
        () => {
          return { focusFirstName: !focusFirstName };
        },
    }
  )
);
export default enhance(LandingPage);
